// packages
import { sum } from 'd3-array';
import { format } from 'd3-format';
import { scaleBand, scaleLinear } from 'd3-scale';
import { select } from 'd3-selection';

// local
import { createBase } from '../../utils/d3-base';

// const percentages = {
//   '0-4': 0.058,
//   '5-17': 0.167,
//   '18-34': 0.243,
//   '35-49': 0.193,
//   '50-59': 0.125,
//   '60-64': 0.059,
//   '65-69': 0.05,
//   '70-74': 0.041,
//   '75-79': 0.027,
//   '80+': 0.039,
// };

export function boot(data, id = 'cases-by-age-chart') {
  const container = select(`#${id}`);
  data = data.reverse();

  render();

  function render() {
    // empty the container on render every time
    container.html('');

    const { g, x, y, width, xAxis, yAxis, drawAxis } = createBase({
      container,
      height: 333,
      x: scaleLinear(),
      y: scaleBand(),
      margin: { left: 50, bottom: 25, top: 5 },
      title: 'Cases by age',
    });

    // set up our x scale
    x.domain([0, 0.5]).nice();

    // set up our y scale
    y.domain(data.map((d) => d.age)).padding(0.2);

    // tell the y axis what we want
    xAxis.tickSize(-width).ticks(4).tickFormat(format('.0%'));

    // draw the axis lines, then remove their domains
    drawAxis();

    // pre-calc the bandwidth, and y(0)
    const x0 = x(0);

    // Draw the bar containers
    const bars = g
      .selectAll('g.race')
      .data(data)
      .join('g')
      .attr('role', 'graphics-object')
      .attr('class', 'age')
      .attr('data-age', (d) => d.age);

    // Population bar
    bars
      .append('rect')
      .attr('fill', '#dadfe1')
      .attr('fill-opacity', '0.7')
      .attr('data-value', (d) => 0.1)
      .attr('role', 'graphics-symbol')
      .attr('x', x0)
      .attr('y', (d) => y(d.age))
      .attr('width', (d) => x(d.population_pct))
      .attr('height', y.bandwidth());

    // Case bar
    bars
      .append('rect')
      .attr('fill', '#85B8C6')
      .attr('fill-opacity', '0.85')
      .attr('data-value', (d) => d.cases_pct)
      .attr('role', 'graphics-symbol')
      .attr('x', x0)
      .attr('y', (d) => y(d.age) + y.bandwidth() * 0.33)
      .attr('width', (d) => x(d.cases_pct))
      .attr('height', y.bandwidth() * 0.33);
  }
  return render;
}
